/**
 * Created by CCristi on 11/14/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomStrategy = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractStrategy2 = require('./AbstractStrategy');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let CustomStrategy = exports.CustomStrategy = function (_AbstractStrategy) {
  _inherits(CustomStrategy, _AbstractStrategy);

  /**
   * @param {Function} onError
   * @param {Function} onSuccess
   */
  function CustomStrategy() {
    let onError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => false;
    let onSuccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => false;

    _classCallCheck(this, CustomStrategy);

    var _this = _possibleConstructorReturn(this, (CustomStrategy.__proto__ || Object.getPrototypeOf(CustomStrategy)).call(this));

    _this._onErrorCb = onError;
    _this._onSuccessCb = onSuccess;
    return _this;
  }

  /**
   * @param {Response} response
   * @returns {*}
   */


  _createClass(CustomStrategy, [{
    key: 'onSuccess',
    value: function onSuccess(response) {
      return this._onSuccessCb(response);
    }

    /**
     * @param {Response} response
     * @returns {*}
     */

  }, {
    key: 'onError',
    value: function onError(response) {
      return this._onErrorCb(response);
    }
  }]);

  return CustomStrategy;
}(_AbstractStrategy2.AbstractStrategy);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/RetryStrategy/CustomStrategy.js
// module id = 98
// module chunks = 0